import Loading from "@fuse/components/FuseLoadable/Loading";
import { withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import _ from "lodash";
import React from "react";
import Factory from "../../Formatadores/Factory";


const styles = theme => ({
    toolbar: {
        backgroundColor: theme.palette.type === "dark" ? "rgb(255, 255, 255, .1)" : "rgb(0, 0, 0, .08)"
    },
});

const TIPO_ONBOARDING = 4;
const TIPO_HELP = 5;

class Onboarding extends XAPPComponent {

    componentDidMount() {
        this.listMensagem(TIPO_ONBOARDING);
    }

    componentDidUpdate() {
        const { Comunicador } = this.props;
        if (Comunicador.error) {
            this.props.showMessage({
                message: Comunicador.error,
                variant: "error"
            });
            Comunicador.error = null;
        }
        if (Comunicador.warning) {
            this.props.showMessage({
                message: Comunicador.warning,
                variant: "warning"
            });
            Comunicador.warning = null;
        }
        if (Comunicador.info) {
            Comunicador.info = null;
        }
    }

    listMensagem = (_ATipo) => {
        const { xappRouteParams } = this.props;
        this.props.list("SELECIONAR", xappRouteParams, this.getFiltro(_ATipo));
    };

    getFiltro = (_ATipo) => {
        const { local = null } = this.props;
        let AFiltros = {
            "procedure": "spvwmensagemonboarding",
            "OR": [],
            "AND": [
                { "Campo": "slug", "Operador": "=", "Valor": local },
                { "Campo": "tipo", "Operador": "=", "Valor": _ATipo }]
        };

        return AFiltros;
    };

    save = (_AValue, _AAction) => {
        const { save, xappRouteParams } = this.props;
        save(_AValue, xappRouteParams, _AAction);
    };

    updateDataLeitura = (_AValue, _AData = null) => {
        if (_.isNull(_AData)) {
            _AData = new Date().toISOString();
        }
        this.save({ "idmensagem": _AValue.idmensagem, "idmensagemlocal": _AValue.idmensagemlocal, "dataleitura": _AData }, "UPDATEDATALEITURA");
    };

    render() {
        const { Comunicador, changeContentPainel } = this.props;

        return (
            <React.Fragment>
                <XAPPButton
                    className="p-8"
                    icon="help"
                    type="icon"
                    iconProps="text-20 text-white"
                    onClick={() => {
                        this.listMensagem(TIPO_HELP);
                        changeContentPainel(
                            <div className="xs:py-56 sm:py-128">
                                <Loading pastDelay={true} />
                            </div>
                        );
                    }}
                />
                {!_.isNull(Comunicador.open) && [TIPO_HELP, TIPO_ONBOARDING].includes(Comunicador.open.tipo) &&
                    <Factory
                        {...this.props}
                        data={Comunicador.open}
                        save={this.save}
                        updateDataLeitura={this.updateDataLeitura}
                        idDialog="onboarding"
                    />
                }
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(Onboarding);

